import { render, staticRenderFns } from "./CalendarComponent.vue?vue&type=template&id=f2633a5c&scoped=true"
import script from "./CalendarComponent.vue?vue&type=script&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&lang=js"
import style0 from "./CalendarComponent.vue?vue&type=style&index=0&id=f2633a5c&prod&scoped=true&lang=css"
import style1 from "./CalendarComponent.vue?vue&type=style&index=1&id=f2633a5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2633a5c",
  null
  
)

export default component.exports